import { render, staticRenderFns } from "./my_permission.vue?vue&type=template&id=9c4ea56c&"
import script from "./my_permission.vue?vue&type=script&lang=js&"
export * from "./my_permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports